import React from "react";
import { PlaceHolder } from "../../constants/PlaceHolderConstants";

const RoleInformation = (props) => {
  const { values, errors, handleFormChange, handleStatusChange, handleRedirect } = props;

  return (
    <>
      <div className="card role-info-card mb-2">
        <div className="card-header">
          <h2>Role Information</h2>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-xxl-7 col-xl-7 col-lg-7 col-md-7 col-sm-12 col-xs-12">
              <div>
                <label>
                  Role Name <span className="mandatory">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="roleName"
                  placeholder={PlaceHolder?.ROLE_NAME}
                  onChange={handleFormChange}
                  value={values?.roleName}
                />
                <p className="form-error">{errors?.roleName}</p>
              </div>
            </div>

            <div className="col-xxl-5 col-xl-5 col-lg-5 col-md-5 col-sm-12 col-xs-12">
            </div>
            {values?.id && (
              <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-2 col-sm-12 col-xs-12 mt-3">
                <label>
                  Status <span className="mandatory">*</span>
                </label>
                <div className="form-group mb-0">
                  <input
                    type="checkbox"
                    id="isActive"
                    name="isActive"
                    value={values?.isActive}
                    checked={values?.isActive}
                    onChange={(e) => handleStatusChange(e, "isActive")}
                    className="mr-2"
                  />
                  <label htmlFor="isActive" className="mb-0">
                    {values?.isActive ? "Active" : "Inactive"}
                  </label>
                </div>
              </div>
            )}

            <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-12 col-xs-12 mt-3">
              <label>View Cost Access</label>
              <div className="form-group mb-0">
                <input
                  type="checkbox"
                  style={{ cursor: "pointer" }}
                  id="costing"
                  name="costing"
                  value={values?.canViewCosting}
                  checked={values?.canViewCosting}
                  onChange={(e) => handleStatusChange(e, "costing")}
                  className="mr-2"
                />
                <label htmlFor="costing" className="mb-0">
                  Yes
                </label>
              </div>
            </div>
            <div className="col-xxl-5 col-xl-5 col-lg-5 col-md-5 col-sm-12 col-xs-12 mt-3">
              <div className="form-group mb-0 mt-0 mt-md-3">
                <input
                  type="checkbox"
                  style={{ cursor: "pointer" }}
                  id="applicable"
                  name="applicable"
                  value={values?.onlyForDistributor}
                  checked={values?.onlyForDistributor}
                  onChange={(e) => handleStatusChange(e, "applicable")}
                  className="mr-2"
                />
                <label htmlFor="applicable" className="mb-0">
                  Applicable only to distributor
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RoleInformation;
